import {
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS,
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS,
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR,
  GET_MARKETPLACE_SOURCE_STATS,
  GET_MARKETPLACE_SOURCE_STATS_SUCCESS,
  GET_MARKETPLACE_SOURCE_STATS_ERROR,
  GET_MARKETPLACE_AD_GROUP_STATS,
  GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS,
  GET_MARKETPLACE_AD_GROUP_STATS_ERROR,
  GET_MARKETPLACE_DASHBOARD_STATS,
  CANCEL_MARKETPLACE_DASHBOARD_STATS,
  GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS,
  GET_MARKETPLACE_DASHBOARD_STATS_ERROR
} from "./actionTypes"

export const getAggMarketplaceStatsForCampaigns = (campaigns_params) => {
  return {
    type: GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS,
    payload: campaigns_params
  }
}

export const getAggMarketplaceStatsForCampaignsSuccess = (marketplace_stats) => {
  return {
    type: GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS,
    payload: marketplace_stats
  }
}

export const getAggMarketplaceStatsForCampaignsError = (error) => {
  return {
    type: GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR,
    payload: error
  }
}

export const getMarketplaceSourceStats = (source_stats_params) => {
  return {
    type: GET_MARKETPLACE_SOURCE_STATS,
    payload: source_stats_params
  }
}

export const getMarketplaceSourceStatsSuccess = (source_stats) => {
  return {
    type: GET_MARKETPLACE_SOURCE_STATS_SUCCESS,
    payload: source_stats
  }
}

export const getMarketplaceSourceStatsError = (error) => {
  return {
    type: GET_MARKETPLACE_SOURCE_STATS_ERROR,
    payload: error
  }
}

export const getMarketplaceAdGroupStats = (ad_group_stats_params) => {
  return {
    type: GET_MARKETPLACE_AD_GROUP_STATS,
    payload: ad_group_stats_params
  }
}

export const getMarketplaceAdGroupStatsSuccess = (ad_group_stats) => {
  return {
    type: GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS,
    payload: ad_group_stats
  }
}

export const getMarketplaceAdGroupStatsError = (error) => {
  return {
    type: GET_MARKETPLACE_AD_GROUP_STATS_ERROR,
    payload: error
  }
}

export const getMarketplaceDashboardStats = (dashboard_params) => {
  return {
    type: GET_MARKETPLACE_DASHBOARD_STATS,
    payload: dashboard_params
  }
}

export const cancelMarketplaceDashboardStats = () => {
  return {
    type: CANCEL_MARKETPLACE_DASHBOARD_STATS
  }
}

export const getMarketplaceDashboardStatsSuccess = (dashboard_stats) => {
  return {
    type: GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS,
    payload: dashboard_stats
  }
}

export const getMarketplaceDashboardStatsError = (error) => {
  return {
    type: GET_MARKETPLACE_DASHBOARD_STATS_ERROR,
    payload: error
  }
}
